import React, { useState, useEffect } from 'react';
import InputField from '../InputField/InputField';
import ButtonSecondary from '../Button/ButtonSecondary';
import { DetailModal, DetailModalContent } from './styles';
import { getProductByName } from '../../api';
import { FiBox } from 'react-icons/fi';
import Button from '../Button/Button';
import './_styles.search-modal.scss';
import moment from 'moment';

const SearchModal = ({ visible, onClose, site, onSelect }) => {
  const [searchVal, setSearchVal] = useState('');
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [lotSearch, setLotSearch] = useState('');

  const OnSearchChange = async (e) => {
    setSearchVal(e.target.value);
  };

  const OnLotChange = async (e) => {
    setLotSearch(e.target.value);
  };

  const OnProductSelect = (barcode, lotId) => {
    document.getElementById('searchInput').value = '';
    setResults([]);
    onSelect(barcode, lotId);
  };

  const search = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResults([]);
    const { data } = await getProductByName(searchVal, site);
    setLotSearch('');
    setResults(data);
    setIsLoading(false);
  };

  // useEffect(() => {
  //   const getProds = async () => {
  //     setIsLoading(true);
  //     setResults([]);
  //     const rv = searchVal;
  //     const { data } = await getProductByName(searchVal, site);
  //     console.log(data);
  //     setResultSearchVal(rv);
  //     setResults(data);
  //     setIsLoading(false);
  //   };
  //   if (searchVal != resultSearchVal) {
  //     getProds();
  //   }
  // }, [searchVal, resultSearchVal]);

  return (
    <DetailModal style={{ display: visible ? 'block' : 'none' }}>
      <DetailModalContent
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <form onSubmit={search}>
          <InputField
            placeholder='Search'
            onChange={OnSearchChange}
            id='searchInput'
            customStyle={{ width: '100%' }}
          />
          {results.length > 0 && (
            <InputField
              placeholder='Filter by lot'
              onChange={OnLotChange}
              id='lotInput'
              customStyle={{ width: '100%' }}
            />
          )}
          <div className='search-results'>
            {isLoading && <p>Searching...</p>}
            {!isLoading && results.length == 0 && <p>No results</p>}
            {results
              ?.filter((p) =>
                p.ref_desc ? p.ref_desc.includes(lotSearch) : true
              )
              ?.map((product) => {
                const expired = moment(product.exp_date).isBefore(moment());
                return (
                  <div
                    className={`searchResult ${expired ? 'expired' : ''}`}
                    key={Math.random()}
                    onClick={() => {
                      OnProductSelect(product.barcode, product.lot_id);
                    }}
                  >
                    <FiBox size={30} />
                    <div>
                      <p>{product.short_name}</p>
                      <div className='lot-details'>
                        <p>
                          <strong>Lot:</strong> {product.ref_desc}
                        </p>
                        {product.exp_date && (
                          <p>
                            <strong>Expiry:</strong>{' '}
                            {moment(product.exp_date).format('DD/MM/YYYY')}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          <div className='buttons'>
            <Button title='Search' onClick={search} />
            <ButtonSecondary title='Cancel' onClick={onClose} />
          </div>
        </form>
      </DetailModalContent>
    </DetailModal>
  );
};

export default SearchModal;
